// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"701":"0bbc0616","732":"9d30f63d"}[chunkId] + ".chunk.js";
};